import React from 'react'
import { CFooter } from '@coreui/react'

const TheFooter = () => {
  return (
    <CFooter fixed={false}>
      <div className="mfs-auto">
        <a href="https://www.foramind.com" target="_blank" rel="noopener noreferrer">Foramind</a>
        <span className="ml-1">&copy; 2021 Foramind.</span>
      </div>
    </CFooter>
  )
}

export default React.memo(TheFooter)
